import ProjectHeroMealIdeaGenerator from "../../../components/ProjectHero/MealIdeaGenerator/ProjectHeroMealIdeaGenerator";
import ProjectDetailsMealIdeaGenerator from "../../../components/ProjectDetails/MealIdeaGenerator/ProjectDetailsMealIdeaGenerator";


function ProjectPageMealIdeaGenerator() {
    return (
        <>
            <ProjectHeroMealIdeaGenerator />
            <ProjectDetailsMealIdeaGenerator />
        </>
    )
}

export default ProjectPageMealIdeaGenerator;